import { useMemo } from 'react';
import type { ImageSourcePropType } from 'react-native';
import { useT } from '@transifex/react';

export type BrandSlide = {
  key: string;
  image: ImageSourcePropType;
  title: string;
  body: string;
};

// Placeholder media from the rebrand Figma; swap the files in assets/images/brand to change them.
export const useBrandSlides = (): BrandSlide[] => {
  const t = useT();

  return useMemo(
    () => [
      {
        key: 'care-team',
        image: require('../../assets/images/brand/slide-2-golden-hour.jpg'),
        title: t('Your care team,\nby your side.'),
        body: t('Meet with clinicians and coaches, and message them between visits.'),
      },
      {
        key: 'one-plan',
        image: require('../../assets/images/brand/slide-3-video-visit.jpg'),
        title: t('One plan.\nThe whole you.'),
        body: t('Medication, nutrition, movement, sleep and stress, in one plan built around you.'),
      },
      {
        key: 'progress',
        image: require('../../assets/images/brand/slide-4-sun.jpg'),
        title: t('Progress at\nyour own pace.'),
        body: t('Small steps that fit your week, with support when life changes.'),
      },
      {
        key: 'care',
        image: require('../../assets/images/brand/slide-1-hiker.jpg'),
        title: t('Care that makes\nroom for life.'),
        body: t('Personalized care for your weight, blood sugar and everyday health.'),
      },
    ],
    [t]
  );
};
